import { get } from 'lodash';

import Anchor from 'components/ui/basic/anchor';
import salsifyLogo from 'images/logo-salsify.png';
import { getByLocale } from 'utils/i18n';

import { useBrandingConfig } from '../../hooks/branding';

import './footer.scss';

export default function AuthLayoutFooter() {
  const footer = useBrandingConfig().footer;
  const links = get(footer, 'public.links') || [];
  const addon = get(footer, 'public.addon');
  return (
    <div className="AuthLayoutFooter">
      {!!addon && (
        <div className="AuthLayoutFooterAddon">
          <img
            className="AuthLayoutFooterAddon__background"
            src={addon.background}
            alt=""
          />
          <div className="AuthLayoutFooterAddon__overlay">
            <div
              className="AuthLayoutFooterAddon__colorOverlay"
              style={{ backgroundColor: addon.primaryColor }}
            />
            <h2 className="AuthLayoutFooterAddon__title">{addon.title}</h2>
            <div className="AuthLayoutFooterAddon__links">
              {addon.links &&
                addon.links.map((link) => (
                  <a
                    key={link.url}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary AuthLayoutFooterAddon__link"
                    style={{
                      backgroundColor: addon.secondaryColor,
                      borderColor: addon.secondaryColor,
                    }}
                  >
                    {link.title}
                  </a>
                ))}
            </div>
          </div>
        </div>
      )}
      <ul className="AuthLayoutFooter__links alk-list alk-flex">
        {links.map(({ label, url }) => (
          <li key={label}>
            <Anchor href={url}>{label}</Anchor>
          </li>
        ))}
      </ul>
      <div className="AuthLayoutFooter__logo AuthLayoutFooter__logo--salsify">
        <Anchor
          href={getByLocale({
            en: 'https://www.salsify.com/platform/supplierxm',
            fr: 'https://www.salsify.com/fr/platform/supplierxm',
          })}
        >
          <img className="logo" src={salsifyLogo} alt="Salsify" />
        </Anchor>
      </div>
    </div>
  );
}
